<template>

	<div class="gray-bg" style="min-height: 100vh">
    
    <div class="middle-box text-center animated fadeInDown">
      <!-- <h1>500</h1> -->
      <h3 class="font-bold">{{ error || 'Redirecting...' }} </h3>
    </div>

  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageRedirect",
  data(){
    return {
      username : "",
      password : "",
      error : ""
    }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
    
    this.handleSubmit();
  },
  methods : {
    async handleSubmit(e){
      // e.preventDefault();

      // let user =  await this.$http
      //   .post(helper.API_URL + '/api2/auth/login', {
      //     email: this.username,
      //     password: this.password
      //   })
      //   .then(response => {
      //     let user = {};
      //     user.username = this.username;
      //     user.userID = response.data.userID;
      //     user.jwt = response.data.token;
      //     return user;
      //     // user.jwt = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywiaWF0IjoxNTQwNTI1MTAxLCJleHAiOjE1NDA2MTE1MDF9.uGLHTtPi8qZSia4gTLNmIvh1pZOWtAPV9V9aorx_vgQ';
      //   })
      //   .catch((error) => {
      //     this.error = 'Problem logging in. ' + this.parseLoginError(error);
      //   });

      // if(!user) {
      //   this.error = 'Problem logging in.';
      //   return;
      // }
      
      if(!this.$route.query.email || !this.$route.query.jwt) {
        helper.redirect(helper.WEB_URL + '/login');
        return;
      }

      let user = {};
      user.username = this.$route.query.email;
      user.jwt = this.$route.query.jwt;

      helper.setUser(this, user);
    },
    parseLoginError(error) {
      if(error) {
        if(error.response) {
          if(error.response.data) {
            if(error.response.data.message) {
              return error.response.data.message;
            }

            if(typeof a_string === 'string') {
              return error.response.data;
            }
          }

          if(typeof a_string === 'string') {
            return error.response;
          }
        }
      }

      return 'Please try again.'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageRedirect.vue